<template>
  <path
    d="M16.01 7.00024L16 4.00024C16 3.45024 15.55 3.00024 15 3.00024C14.45 3.00024 14 3.45024 14 4.00024V7.00024H10V4.00024C10 3.45024 9.55 3.00024 9 3.00024C8.45 3.00024 8 3.45024 8 4.00024V7.00024H7.99C6.9 7.00024 6 7.90024 6 8.99024V13.6502C6 14.1802 6.21 14.6902 6.58 15.0602L9.5 18.0002V20.0002C9.5 20.5502 9.95 21.0002 10.5 21.0002H13.5C14.05 21.0002 14.5 20.5502 14.5 20.0002V18.0002L17.42 15.0802C17.79 14.7002 18 14.1902 18 13.6602V8.99024C18 7.89024 17.11 7.00024 16.01 7.00024Z"
  />
</template>
